import { PaginationObject } from '../models/paginationObject';

export default {
    constructPagination: (pagination: PaginationObject) => {
        const page = pagination.offset ? pagination.offset : 0;
        const size = pagination.pageSize != 0 ? pagination.pageSize : 10;
        return '?page=' + page + '&size=' + size;
    },
  };
  